import React from "react";

export const ThreeDotsLoaderAnimatedSvg = (
  props: React.SVGProps<SVGSVGElement>
) => {
  const {
    width = 120,
    height = 30,
    viewBox = `0 0 ${width} ${height}`,
    fill = "#fff",
  } = props;

  const radius = Number(height) / 2;
  const widthValue = Number(width);
  const heightValue = Number(height);

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={widthValue / 8} cy={heightValue / 2} r={radius}>
        <animate
          attributeName="r"
          from={radius}
          to={radius}
          begin="0s"
          dur="0.8s"
          values={`${radius}; ${radius / 1.5}; ${radius}`}
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx={widthValue / 2}
        cy={heightValue / 2}
        r={radius / 1.5}
        fillOpacity="0.3"
      >
        <animate
          attributeName="r"
          from={radius / 1.5}
          to={radius / 1.5}
          begin="0s"
          dur="0.8s"
          values={`${radius / 1.5}; ${radius}; ${radius / 1.5}`}
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="0.5"
          to="0.5"
          begin="0s"
          dur="0.8s"
          values=".5;1;.5"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={widthValue / 1.14} cy={heightValue / 2} r={radius}>
        <animate
          attributeName="r"
          from={radius}
          to={radius}
          begin="0s"
          dur="0.8s"
          values={`${radius}; ${radius / 1.5}; ${radius}`}
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};
